import Axios from "axios";

export const getBranches = async (data) => {

  const result = await Axios.get(process.env.VUE_APP_BACKEND_URL + `api/home-branches`, {
    params: {
      ...data
    }
  });

  return result;
}
